import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Button from "../components/Button";
import Dialog from "../components/Dialog";

const UnsavedChangesDialogControls = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space[4]};
`;

const UnsavedCopy = styled.div`
  padding: 1rem 0;
  font-family: ${(props) => props.theme.fonts.impact};
  font-size: ${({ theme }) => theme.fontSizes[6]};
  text-transform: uppercase;
  line-height: 1;
  margin: 0 1rem;
  color: ${({ theme }) => theme.colors.primary};
`;

const UnsavedChangesDialogCopy = styled.p`
  margin: 0;
  margin-bottom: ${({ theme }) => theme.space[6]};
  font-size: ${({ theme }) => theme.fontSizes[3]};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
`;

export interface IUnsavedChangesDialog {
  handleConfirm: () => void;
  handleHide: () => void;
}

const UnsavedChangesDialog: React.FC<IUnsavedChangesDialog> = ({
  handleConfirm,
  handleHide,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog closeDialog={handleHide}>
      <Dialog.Header closeDialog={handleHide}>
        <UnsavedCopy>
          {t("unsavedChangesModal.heading", "You have unsaved changes")}
        </UnsavedCopy>
      </Dialog.Header>
      <Dialog.Body isPadded={true}>
        <UnsavedChangesDialogCopy>
          {t(
            "unsavedChangesModal.body",
            "Are you sure you want to leave this page?",
          )}
        </UnsavedChangesDialogCopy>
        <UnsavedChangesDialogControls>
          <Button onClick={handleHide} width={1}>
            {t("unsavedChangesModal.negative", "No")}
          </Button>
          <Button variant="primary" onClick={handleConfirm} width={1}>
            {t("unsavedChangesModal.affirmative", "Yes")}
          </Button>
        </UnsavedChangesDialogControls>
      </Dialog.Body>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
